export default __webpack_public_path__ + "static/media/abstracto3.5ed97fde.jpg";